module.exports = {
  customRoutes: [
    require("../modules/prismic-demo/web/moduleRoutes.js").default,
  ],
  customDispatchedRoutes: [
    require("../modules/prismic-demo/web/moduleRoutes.js").dispatchedRoutes,
  ],
};
